import React from "react";
import { Link } from "react-router-dom";
import "./LegalPages.css";
import AnimatedPage from "../../components/AnimatedPage/AnimatedPage";
import { translations } from "../../utils/translations";

const PrivacyPolicy = () => {
  // logica del idioma
  const currentLang = localStorage.getItem("language") || "es";
  const t =
    translations[currentLang]?.privacyPolicy ||
    translations["es"].privacyPolicy;

  return (
    <AnimatedPage>
      <div className="legal-container">
        <Link to="/" className="legal-back-btn">
          {t.backBtn}
        </Link>
        <h1>{t.mainTitle}</h1>
        <p>{t.lastUpdate}</p>

        <section>
          <h2>{t.sec1Title}</h2>
          <p>{t.sec1Text}</p>
        </section>

        <section>
          <h2>{t.sec2Title}</h2>

          <h3>{t.sec2Sub1}</h3>
          <p>{t.sec2Text1}</p>
          <ul>
            <li>{t.sec2List1Item1}</li>
            <li>{t.sec2List1Item2}</li>
            <li>{t.sec2List1Item3}</li>
            <li>{t.sec2List1Item4}</li>
          </ul>

          <h3>{t.sec2Sub2}</h3>
          <p>{t.sec2Text2}</p>
          <ul>
            <li>{t.sec2List2Item1}</li>
            <li>{t.sec2List2Item2}</li>
            <li>{t.sec2List2Item3}</li>
            <li>{t.sec2List2Item4}</li>
          </ul>

          <p>
            <strong>{t.sec2Important}</strong>
          </p>
        </section>

        <section>
          <h2>{t.sec3Title}</h2>

          <h3>{t.sec3Sub1}</h3>
          <p>{t.sec3Text1}</p>
          <ul>
            <li>{t.sec3List1Item1}</li>
            <li>{t.sec3List1Item2}</li>
            <li>{t.sec3List1Item3}</li>
            <li>{t.sec3List1Item4}</li>
          </ul>

          <h3>{t.sec3Sub2}</h3>
          <p>{t.sec3Text2}</p>
          <ul>
            <li>{t.sec3List2Item1}</li>
            <li>{t.sec3List2Item2}</li>
            <li>{t.sec3List2Item3}</li>
          </ul>

          <p>{t.sec3ComplianceTitle}</p>
          <ul>
            <li>{t.sec3ComplianceItem1}</li>
            <li>{t.sec3ComplianceItem2}</li>
            <li>{t.sec3ComplianceItem3}</li>
            <li>{t.sec3ComplianceItem4}</li>
          </ul>

          <p>
            {t.sec3GooglePolicyText}{" "}
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noreferrer"
            >
              {t.sec3GooglePolicyLink}
            </a>
          </p>
        </section>

        <section>
          <h2>{t.sec4Title}</h2>

          <h3>{t.sec4Sub1}</h3>
          <p>{t.sec4Text1}</p>

          <h3>{t.sec4Sub2}</h3>
          <p>{t.sec4Text2}</p>
          <ul>
            <li>{t.sec4List1Item1}</li>
            <li>{t.sec4List1Item2}</li>
          </ul>
          <p>{t.sec4Note1}</p>

          <h3>{t.sec4Sub3}</h3>
          <p>{t.sec4Text3}</p>
          <ul>
            <li>{t.sec4List2Item1}</li>
            <li>{t.sec4List2Item2}</li>
            <li>{t.sec4List2Item3}</li>
          </ul>
          <p>{t.sec4Note2}</p>

          <h3>{t.sec4Sub4}</h3>
          <p>{t.sec4Text4}</p>
          <ul>
            <li>{t.sec4List3Item1}</li>
            <li>{t.sec4List3Item2}</li>
            <li>{t.sec4List3Item3}</li>
          </ul>

          <h3>{t.sec4Sub5}</h3>
          <p>{t.sec4Text5}</p>
          <ul>
            <li>{t.sec4List4Item1}</li>
            <li>{t.sec4List4Item2}</li>
            <li>{t.sec4List4Item3}</li>
          </ul>

          <h3>{t.sec4Sub6}</h3>
          <p>{t.sec4Text6}</p>
          <ul>
            <li>{t.sec4List5Item1}</li>
            <li>{t.sec4List5Item2}</li>
          </ul>
          <p>{t.sec4Note3}</p>
        </section>

        <section>
          <h2>{t.sec5Title}</h2>

          <h3>{t.sec5Sub1}</h3>
          <p>{t.sec5Text1}</p>
          <ul>
            <li>{t.sec5List1Item1}</li>
            <li>{t.sec5List1Item2}</li>
            <li>{t.sec5List1Item3}</li>
          </ul>

          <h3>{t.sec5Sub2}</h3>
          <ul>
            <li>{t.sec5List2Item1}</li>
            <li>{t.sec5List2Item2}</li>
            <li>{t.sec5List2Item3}</li>
          </ul>
        </section>

        <section>
          <h2>{t.sec6Title}</h2>
          <p>{t.sec6Text}</p>
          <ul>
            <li>{t.sec6ListItem1}</li>
            <li>{t.sec6ListItem2}</li>
            <li>{t.sec6ListItem3}</li>
            <li>{t.sec6ListItem4}</li>
            <li>{t.sec6ListItem5}</li>
            <li>{t.sec6ListItem6}</li>
          </ul>
        </section>

        <section>
          <h2>{t.sec7Title}</h2>
          <p>{t.sec7Text}</p>
          <ul>
            <li>{t.sec7List1Item1}</li>
            <li>{t.sec7List1Item2}</li>
            <li>{t.sec7List1Item3}</li>
            <li>{t.sec7List1Item4}</li>
            <li>{t.sec7List1Item5}</li>
            <li>{t.sec7List1Item6}</li>
          </ul>

          <p>
            <strong>{t.sec7Text2}</strong>
          </p>
          <ul>
            <li>
              {t.sec7List2Item1}{" "}
              <a href="mailto:hola@replikers.com">hola@replikers.com</a>
            </li>
            <li>
              {t.sec7List2Item2}{" "}
              <a
                href="https://myaccount.google.com/permissions"
                target="_blank"
                rel="noreferrer"
              >
                https://myaccount.google.com/permissions
              </a>
            </li>
            <li>{t.sec7List2Item3}</li>
          </ul>
        </section>

        <section>
          <h2>{t.sec8Title}</h2>
          <p>
            {t.sec8Text}{" "}
            <a href="mailto:hola@replikers.com">hola@replikers.com</a>
          </p>
        </section>
      </div>
    </AnimatedPage>
  );
};

export default PrivacyPolicy;
